module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Triangle.js"));
	}, "Triangle");
}